/* global axios */
import ApiClient from '../ApiClient';

class FinancialObligationsAPI extends ApiClient {
  constructor() {
    super('financeiro/obligations', { accountScoped: true });
  }

  getAll({
    type,
    status,
    owner_type: ownerType,
    owner_id: ownerId,
    search,
    // O cliente (contato que paga) — "o financeiro próprio do cliente", vindo
    // da pasta (14/10/2026). Sem repassar aqui o servidor nunca filtra.
    cliente,
    due_date_start: dueDateStart,
    due_date_end: dueDateEnd,
    // Data da QUITAÇÃO (06/10/2026): o cartão "Quitadas no mês" abre a lista
    // com ela — sem repassar aqui, o servidor nunca recebia o filtro.
    settlement_date_start: settlementDateStart,
    settlement_date_end: settlementDateEnd,
    amount_min: amountMin,
    amount_max: amountMax,
    sort_by: sortBy,
    sort_dir: sortDir,
    page,
    per_page: perPage,
  } = {}) {
    return axios.get(this.url, {
      params: {
        type,
        status,
        owner_type: ownerType,
        owner_id: ownerId,
        search,
        cliente,
        due_date_start: dueDateStart,
        due_date_end: dueDateEnd,
        settlement_date_start: settlementDateStart,
        settlement_date_end: settlementDateEnd,
        amount_min: amountMin,
        amount_max: amountMax,
        sort_by: sortBy,
        sort_dir: sortDir,
        page,
        per_page: perPage,
      },
    });
  }

  // Quem paga tem CPF e telefone? Sem isso a obrigação não se grava.
  checarPagador({ contactId, obligationType, retroactive }) {
    return axios.get(`${this.url}/checar_pagador`, {
      params: {
        contact_id: contactId,
        obligation_type: obligationType,
        retroactive,
      },
    });
  }

  getById(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { financial_obligation: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { financial_obligation: data });
  }

  // Pausar/retomar a cobrança de uma parcela: é decisão da obrigação, e o
  // quadro do motor também usa.
  toggleDunningPause(id) {
    return axios.patch(`${this.url}/${id}/toggle_dunning_pause`);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  stats({ startDate, endDate } = {}) {
    return axios.get(`${this.url}/stats`, {
      params: { start_date: startDate, end_date: endDate },
    });
  }

  cashflow({ startDate, endDate } = {}) {
    return axios.get(`${this.url}/cashflow`, {
      params: { start_date: startDate, end_date: endDate },
    });
  }

  aging() {
    return axios.get(`${this.url}/aging`);
  }

  export(params = {}) {
    return axios.get(`${this.url}/export`, {
      params: {
        type: params.type,
        status: params.status,
        search: params.search,
        due_date_start: params.due_date_start,
        due_date_end: params.due_date_end,
        settlement_date_start: params.settlement_date_start,
        settlement_date_end: params.settlement_date_end,
        amount_min: params.amount_min,
        amount_max: params.amount_max,
      },
      responseType: 'blob',
    });
  }

  settle(id, data) {
    return axios.post(`${this.url}/${id}/settle`, data);
  }

  // Desfaz uma quitação: apaga o movimento e devolve o saldo da conta.
  unsettle(id, data) {
    return axios.post(`${this.url}/${id}/unsettle`, data);
  }

  requestApproval(id) {
    return axios.post(`${this.url}/${id}/request_approval`);
  }

  // Emite o boleto/Pix no Asaas para esta obrigação.
  generateCharge(id) {
    return axios.post(`${this.url}/${id}/generate_charge`);
  }
}

export default new FinancialObligationsAPI();
